import { render, staticRenderFns } from "./workebench.vue?vue&type=template&id=c47863c4&scoped=true&"
import script from "./workebench.vue?vue&type=script&lang=js&"
export * from "./workebench.vue?vue&type=script&lang=js&"
import style0 from "./workebench.vue?vue&type=style&index=0&id=c47863c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47863c4",
  null
  
)

export default component.exports